import React, { Component } from 'react';
import Header from '../../.././Header';
import Image from '../../.././Image';
import classnames from 'classnames';

export default class Quality extends Component {
  // static propTypes = {}
  // static defaultProps = {}
  // state = {}

  render() {
    const { className } = this.props;

    const navLinks = [
      {path: "/projects", title: "Projects"},
      {path: "/projects/quora", title: "Quora"}
    ]

    return (
      <div className={classnames('Quality', className)}>
        <Header links={navLinks} />
        <div className="container">
          <div className="section">
            <div className="section-content">
              <div className="section-header">Content Quality</div>
              <div className="section-title">Description</div>
              <div className="section-copy">
                <ul>
                  <li><strong>Objective</strong>: Improving content quality through behavioral reinforcement</li>
                  <li><strong>Role</strong>: Product designer</li>
                  <li><strong>Duration</strong>: May 2015—Oct 2015 (6 months)</li>
                </ul>
              </div>
              <div className="section-title">Summary</div>
              <div className="section-copy">
                <p>
                  Coming soon.
                </p>
              </div>
              <div className="section-title">Links</div>
              <div className="section-copy">
                <ul>
                  <li><a href="https://productupdates.quora.com/New-Question-Downvoting-One-Simple-Way-to-Tell-Quora-That-a-Question-is-Bad">New Question Downvoting: One Simple Way to Tell Quora That a Question is Bad</a></li>
                  <li><a href="https://productupdates.quora.com/Making-Question-Downvotes-More-Powerful">Making Question Downvotes More Powerful</a></li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Projects/Quora/Quality/index.js